/// <amd-module name="Test/ManualTestReports/TestReportsCommon/BasePageLayoutComponent" />
import { IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { IVssPerformanceService } from "VSS/Platform/Performance";
import * as TelemetryService from "Test/ManualTestReports/TestReportsCommon/TelemetryService";

export interface IPageLayoutComponentTelemetryProps extends IVssComponentProperties{

    area: string;

    /*
      Main layout telemetry name. Used to log telemetry from
      navigation start to main layout rendered(Not includes child widget rendring time).
    */
    pageLayoutTelemetryName: string;

    /*
      Page telemetry name. Used to log telemetry from
      navigation start to all widgets rendered.
    */
    pageTelemetryName: string;
    widgetNameToPerfTelemetryName: { [key:string]: string };
}

export abstract class BasePageLayoutComponent<P extends IVssComponentProperties = IVssComponentProperties, S = {}, SS = {}> extends VssComponent<P, S, SS>  {

    // Telemetry related variables.
    private _perfService: IVssPerformanceService;
    private _renderedWidgets: Set<string> = new Set();
    private _numOfChildrenWidgets: number;
    private _isPageTelemetryLogged: boolean = false;
    protected _defaultTelemetryData: { [key:string]: string };
    private _telemetryProps: IPageLayoutComponentTelemetryProps;
    
    constructor(props: P, context: IVssComponentContext) {
        super(props, context);
        this._perfService = this.context.pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
        this._setupForTelemetry();
    }

    public componentDidMount(){
        super.componentDidMount();
        this._perfService.markTimeToInteractive(this._telemetryProps.area, this._telemetryProps.pageLayoutTelemetryName);
    }

    protected abstract getTelemetryProperties(): IPageLayoutComponentTelemetryProps;

    protected onWidgetRenderingStart = (widgetName: string, additionalProps?: {[key: string]: any} ) => {
        this._perfService.startScenario(this._telemetryProps.widgetNameToPerfTelemetryName[widgetName], true, undefined, additionalProps);
    };

    protected onWidgetRenderingEnd = (widgetName: string, additionalProps?: {[key: string]: any} ) => {
        additionalProps = this._addDefaultTelemetryProps(additionalProps, widgetName);
        this._renderedWidgets.add(widgetName);
        this._perfService.endScenario(this._telemetryProps.area , this._telemetryProps.widgetNameToPerfTelemetryName[widgetName], true, undefined, additionalProps);
        this._logPagePerformance();
    };

    private _setupForTelemetry() {
        this._defaultTelemetryData = TelemetryService.getDefaultTelemetryProperties(this.context.pageContext);
        this._telemetryProps = this.getTelemetryProperties();
        this._numOfChildrenWidgets = Object.keys(this._telemetryProps.widgetNameToPerfTelemetryName).length;
    }

    private _addDefaultTelemetryProps(additionalProps: { [key: string]: any; } | undefined, widgetName: string) {
        if (!additionalProps) {
            additionalProps = {};
        }

        let isRefresh: boolean = false;
        if (this._renderedWidgets.has(widgetName)) {
            isRefresh = true;
        }

        additionalProps = { ...additionalProps, ...this._defaultTelemetryData, isRefresh: isRefresh };
        return additionalProps;
    }

    private _logPagePerformance() {
        if (!this._isPageTelemetryLogged && this._isAllWidgetsLoaded()) {
            this._perfService.markTimeToInteractive(this._telemetryProps.area, this._telemetryProps.pageTelemetryName, undefined, this._defaultTelemetryData);
            this._isPageTelemetryLogged = true;
        }
    }

    private _isAllWidgetsLoaded(){
        return this._renderedWidgets.size === this._numOfChildrenWidgets;
    }
}
